/* eslint-disable no-nested-ternary */
import React, { useState, useCallback, useEffect } from 'react'
import { Formik, Field, Form } from 'formik'
import { useTranslation } from 'react-i18next'
import Loading from 'custom/assets/loaders/Loading'
import { SuggestionSchema } from '../../schemas/others/suggestions'
import FeedbackService from '../../services/feedback.service'
import { SIDENAV_KEYS,MENU_SIDEBAR_KEYS, DIALOG_KEYS } from '../../utils/translation-constants'
import InputError from '../../components/InputError/InputError'
import NeoInput from '../../components/NeoInput/NeoInput'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'
import { useHistory } from 'react-router-dom'

export default function Suggestion() {
  const { t } = useTranslation()
  const [stage, setStage] = useState(0)
  const [message, setMessage] = useState('')
  const [feedbackCategories, setFeedbackCategories] = useState({})
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return suggestionForm()
      case 2:
        return <NeoSuccess message={message} linkPath='/dashboard' />
      default:
        return renderLoading()
    }
  }

  useEffect(() => {
    const fetchValues = async () => {
      try {
        setLoading(true)
        const response = await FeedbackService.getFeedbackComplaintCategory()
        setStage(1)
        setFeedbackCategories(response.values)
        setLoading(false)
      } catch (err) {
        setLoading(false)
      }
    }
    fetchValues()
  }, [])

  const submitSuggestion = useCallback(
    async (data, { setSubmitting }) => {
      try {
        setSubmitting(true)
        const response = await FeedbackService.saveFeedback({
          category: data.feedbackCategory,
          suggestion: data.feedback,
          categoryEmail: feedbackCategories[data.feedbackCategory],
        })
        setStage(2)
        setSubmitting(false)
        setMessage(response.message)
      } catch (err) {
        setSubmitting(false)
      }
    },
    [feedbackCategories],
  )

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function suggestionForm() {
    return (
      <Formik
        initialValues={{
          feedbackCategory: '',
          feedback: '',
        }}
        validationSchema={SuggestionSchema}
        onSubmit={submitSuggestion}>
        {({ isSubmitting, errors, touched, handleChange }) => (
          <Form>
            <div className='form-group' >
              <NeoInput
                tabIndex='1'
                mode='select'
                text={t(SIDENAV_KEYS.SUGGESTION_KEYS.CATEGORY)}
                name='feedbackCategory'
                onChange={handleChange}
                keyValue={null}
                list={Object.keys(feedbackCategories)}
              />
              <InputError text={errors.feedbackCategory} touched={touched.feedbackCategory} />
            </div>

            <div className='my-4 form-group'>
              <NeoInput
                tabIndex='2'
                mode='textarea'
                text={t(SIDENAV_KEYS.SUGGESTION_KEYS.FEEDBACK)}
                name='feedback'
                onChange={handleChange}
                rows='7'
                minLength={10}
                maxLength={1000}
              />
              <InputError text={errors.feedback} touched={touched.feedback} />
            </div>

            <div className='mt-5 ml-auto col-12 px-0'>
              {isSubmitting === false ? (
                <NeoButton tabIndex='3' type='submit' disabled={isSubmitting} text='Submit' mode='newDesign' />
              ) : (
                renderLoading()
              )}
            </div>
          </Form>
        )}
      </Formik>
    )
  }
  return (
    <LayoutWithOutAccountCard
      breadCumKey='SUGGESTION'
      showEmptySpace={true}
      keyPath={'SUGGESTIONS'}>
      <div className='new-design-form-style'>
        <div className='heading-style'>{t(MENU_SIDEBAR_KEYS.SUGGESTIONS)}</div>
        {renderSwitch()}
      </div>
    </LayoutWithOutAccountCard>
  )
}
